export enum PrintRoutePlanner {
    CLOSE_PRINT_PREVIEW = 'ClosePrintPreview'
  }
